import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

const eur = (n) => {
  const [i, d] = Math.abs(Number(n || 0)).toFixed(2).split(".");
  return `€ ${Number(n) < 0 ? "-" : ""}${i.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${d}`;
};
export { eur };

export function VociPicker({ voci, selected, onChange }) {
  const toggle = (k) => onChange(selected.includes(k) ? selected.filter((x) => x !== k) : [...selected, k]);
  if (!voci.length) return <div className="text-sm text-slate-400">Nessuna voce nel periodo per questo committente</div>;
  return (
    <div data-testid="pc-voci-picker">
      <div className="mb-2 flex items-center gap-3 text-xs">
        <span className="font-semibold text-slate-600">Voci ({selected.length ? `${selected.length} selezionate` : "tutte"})</span>
        <button type="button" className="text-[#0052FF] hover:underline" onClick={() => onChange([])} data-testid="pc-voci-all">Tutte</button>
      </div>
      <div className="grid max-h-60 gap-1 overflow-y-auto rounded-sm border border-slate-200 p-2 sm:grid-cols-2 lg:grid-cols-3">
        {voci.map((v) => (
          <label key={v.key} className={`flex cursor-pointer items-start gap-2 rounded-sm p-2 text-xs transition-colors ${selected.includes(v.key) ? "bg-blue-50" : "hover:bg-slate-50"}`}>
            <Checkbox checked={selected.includes(v.key)} onCheckedChange={() => toggle(v.key)} data-testid={`pc-voce-${v.key}`} />
            <span className="min-w-0">
              <span className="block font-mono font-semibold text-slate-800">{v.code || "—"}</span>
              <span className="block truncate text-slate-500" title={v.description}>{v.description}</span>
            </span>
            <span className="ml-auto shrink-0 text-[10px] text-slate-400">{v.count}×</span>
          </label>
        ))}
      </div>
    </div>
  );
}

export function SummaryTable({ data }) {
  return (
    <div className="overflow-x-auto rounded-sm border border-slate-200 bg-white" data-testid="pc-summary-table">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
          <tr><th className="p-3">Voce</th><th className="p-3">Descrizione</th><th className="p-3 text-right">Lavori</th><th className="p-3 text-right">Quantità</th><th className="p-3 text-right">Fatturato</th></tr>
        </thead>
        <tbody>
          {data.summary.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-slate-400">Nessun dato</td></tr>}
          {data.summary.map((s) => (
            <tr key={s.key} className="border-t border-slate-100" data-testid={`pc-summary-row-${s.key}`}>
              <td className="p-3 font-mono font-semibold">{s.code || "—"}</td>
              <td className="p-3 text-slate-600">{s.description}</td>
              <td className="p-3 text-right font-mono">{s.jobs}</td>
              <td className="p-3 text-right font-mono">{s.quantity}</td>
              <td className="p-3 text-right font-mono font-bold">{eur(s.amount)}</td>
            </tr>
          ))}
        </tbody>
        {data.summary.length > 0 && (
          <tfoot className="border-t-2 border-slate-200 bg-slate-50 font-bold">
            <tr><td className="p-3" colSpan={2}>Totale</td><td className="p-3 text-right font-mono">{data.total_jobs}</td><td className="p-3 text-right font-mono">{data.total_quantity}</td><td className="p-3 text-right font-mono text-[#0052FF]" data-testid="pc-total-amount">{eur(data.total_amount)}</td></tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

export function DetailTable({ rows }) {
  return (
    <div className="max-h-[480px] overflow-auto rounded-sm border border-slate-200 bg-white" data-testid="pc-detail-table">
      <table className="w-full text-xs">
        <thead className="sticky top-0 bg-slate-50 text-left uppercase tracking-wider text-slate-500">
          <tr><th className="p-2">Data</th><th className="p-2">Tecnico</th><th className="p-2">Rif. intervento</th><th className="p-2">Indirizzo</th><th className="p-2">Voce</th><th className="p-2 text-right">Q.tà</th><th className="p-2 text-right">Prezzo</th><th className="p-2 text-right">Importo</th></tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-t border-slate-100">
              <td className="p-2 font-mono">{r.date}</td><td className="p-2">{r.technician}</td><td className="p-2 font-mono">{r.intervention_ref || "—"}</td>
              <td className="p-2 text-slate-500">{r.address || "—"}</td><td className="p-2 font-mono">{r.key}</td>
              <td className="p-2 text-right font-mono">{r.quantity}</td><td className="p-2 text-right font-mono">{eur(r.unit_price)}</td><td className="p-2 text-right font-mono font-semibold">{eur(r.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
